import React from "react";
import { observer } from "mobx-react";
import { DashboardLayoutTemplateCreateStore } from "../../store";
import { DashboardLayoutTemplateCreateForm } from "./DashboardLayoutTemplateCreateForm";
import { ErrorDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";

export type DashboardLayoutTemplateCreateProps = {
  dashboardLayoutTemplateCreateStore: DashboardLayoutTemplateCreateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const DashboardLayoutTemplateCreate: React.FC<DashboardLayoutTemplateCreateProps> =
  observer(
    ({
      dashboardLayoutTemplateCreateStore,
      showToolbox = true,
      showSaveFooter,
    }) => {
      return (
        <>
          <SavingOverlay open={dashboardLayoutTemplateCreateStore.isSaving} />
          <DashboardLayoutTemplateCreateForm
            dashboardLayoutTemplateCreateStore={
              dashboardLayoutTemplateCreateStore
            }
            nameError={dashboardLayoutTemplateCreateStore.errors.name?.message}
            onNameChange={(value: string) => {
              dashboardLayoutTemplateCreateStore.setNameValue(value);
            }}
            name={dashboardLayoutTemplateCreateStore.entityValues.name}
            forRoleError={
              dashboardLayoutTemplateCreateStore.errors.forRole?.message
            }
            onForRoleChange={(value: string) => {
              dashboardLayoutTemplateCreateStore.setForRoleValue(value);
            }}
            forRole={dashboardLayoutTemplateCreateStore.entityValues.forRole}
            widgetsError={
              dashboardLayoutTemplateCreateStore.errors.widgets?.message
            }
            onWidgetsChange={(value: string) => {
              dashboardLayoutTemplateCreateStore.setWidgetsValue(value);
            }}
            widgets={dashboardLayoutTemplateCreateStore.entityValues.widgets}
            isDefaultError={
              dashboardLayoutTemplateCreateStore.errors.isDefault?.message
            }
            onIsDefaultChange={(value: boolean) => {
              dashboardLayoutTemplateCreateStore.setIsDefaultValue(value);
            }}
            isDefault={
              dashboardLayoutTemplateCreateStore.entityValues.isDefault
            }
            enabledError={
              dashboardLayoutTemplateCreateStore.errors.enabled?.message
            }
            onEnabledChange={(value: boolean) => {
              dashboardLayoutTemplateCreateStore.setEnabledValue(value);
            }}
            enabled={dashboardLayoutTemplateCreateStore.entityValues.enabled}
            isForAllTenantsError={
              dashboardLayoutTemplateCreateStore.errors.isForAllTenants?.message
            }
            onIsForAllTenantsChange={(value: boolean) => {
              dashboardLayoutTemplateCreateStore.setIsForAllTenantsValue(value);
            }}
            isForAllTenants={
              dashboardLayoutTemplateCreateStore.entityValues.isForAllTenants
            }
            showToolbox={showToolbox}
            showSaveFooter={showSaveFooter}
            saving={dashboardLayoutTemplateCreateStore.isProcessing}
            onSave={() =>
              dashboardLayoutTemplateCreateStore.saveNewDashboardLayoutTemplate()
            }
            onCancel={() =>
              dashboardLayoutTemplateCreateStore.cancelNewDashboardLayoutTemplate()
            }
          />
          <ErrorDialog
            open={dashboardLayoutTemplateCreateStore.errorDialogOpened}
            title={dashboardLayoutTemplateCreateStore.errorTitle}
            description={dashboardLayoutTemplateCreateStore.errorDescription}
            onClose={() =>
              dashboardLayoutTemplateCreateStore.closeErrorDialog()
            }
          />
        </>
      );
    }
  );
